import React from 'react';
//import {Link} from 'react-router-dom';
import './UserListEntry.css'
import { fullCountryName } from '../helpers/functions';
import heart from '../static/vectors/heart.svg';
import heartSolid from '../static/vectors/heart-solid-red.svg';
import diamond from '../static/vectors/gem-black.svg';
import USER_STATUSES from '../constants/userStatuses';
import mask from '../static/images/host-icon.png';
import redMask from '../static/images/host-icon-red.png';

const UserListEntry = ({ user, onClick = null, onFavourite = null, isFavourited = false }) => {
  return (
    <div
      className="row user-list-entry"
      onClick={() => {onClick()}}
    >
      <button
        className={`favourite ${(isFavourited)?'solid':''}`}
        onClick={(e) => {e.stopPropagation();onFavourite(user.name, !isFavourited)}}
      >
        <img src={(isFavourited)?heartSolid:heart} alt="heart" />
      </button>
      <div className="photo" style={ {backgroundImage: `url('${user.photo_url}')`} }/>
      <div className="texts">
        {user.refCode && user.refCode.length > 0 && user.refCode !== 'disabled' && user.refCode !== 'pending' &&
        <div className="host">
          <img src={mask} alt={"mask"} />
        </div>}
        {user.elite === 1 &&
        <div className="host">
          <img src={redMask} alt={"mask"} />
        </div>}
        <div className="name">{user.name}</div>
        <div className="location">{`${user.city}, ${fullCountryName(user.country)}`}</div>
        <div className="row">
          <div className="col col-12 col-sm-6 info">
            <div className="label">Height</div>
            <div className="value">{`${user.height} cm`}</div>
          </div>
          <div className="col col-12 col-sm-6 info">
            <div className="label">Ethnicity</div>
            <div className="value">{user.ethnicity}</div>
          </div>
          <div className="col col-12 col-sm-6 info">
            <div className="label">Body</div>
            <div className="value">{user.bodyType}</div>
          </div>
          <div className="col col-12 col-sm-6 info">
            <div className="label">Lifestyle Expectation</div>
            <div className="value">{user.lifestyleExpectations}</div>
          </div>
          {user.status === USER_STATUSES.superior && <div className="col col-12 col-sm-6 info superior">
            <div className="value"><img src={diamond} alt={'diamond'} /></div>
            <div className="label">Superior</div>
          </div>}
        </div>
      </div>
    </div>
  )
}

export default UserListEntry;


// WEBPACK FOOTER //
// ./src/components/UserListEntry.js